<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <!-- Breadcrumb Section -->
                <div class="breadcrumbnew">
                    <span>Survey</span>
                    <a>List View</a>
                </div>
                <div class="d-flex flex-wrap align-items-center margin486">
                    <button class="btn btn-new-danger btn-wide px-6 mr-4" v-if="userPermissions.survey_forms.permitted_actions.delete" @click="showDeleteSurvey" :disabled="survey_form_selected.length < 1 || disableDelete == true || delatesurveymodal == true" style="position: relative">- Delete</button>
                    <button class="btn btn-new-green btn-wide px-6" v-if="userPermissions.survey_forms.permitted_actions.create" @click="$router.push('/surveyform/create')" >+ Create New</button>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <!-- <div class="d-flex">
                    <div class="blue_header pointer">
                        <span>List View</span>
                    </div>
                    <div class="blue_header_triangle pointer"></div>
                </div> -->
                <!-- Tabs Section -->
                <div class="tabs tabs-style-shape">
                    <svg class="hidden" style="position: absolute;width: 0;height: 0;opacity: 0;">
                        <defs>
                            <path id="tabshape" d="M80,60C34,53.5,64.417,0,0,0v60H80z"/>
                        </defs>
                    </svg>
                    <nav>
                        <ul class="ml-0">
                            <li class="tab-current">
                                <a href="javascript:;" style="text-decoration: none !important;">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                    <span>List View</span>
                                </a>
                            </li>
                            <!-- For styling we need this tag  -->
                            <li style="width: 0px !important;flex: 0 !important;">
                                <a href="#section-shape-3" style="margin: 0">
                                    <svg viewBox="0 0 80 60" preserveAspectRatio="none"><use xlink:href="#tabshape"></use></svg>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <div class="d-flex ml-4" style="flex-grow: 1;position: relative;margin-left: -20px !important;">
                        <i class="icon icon-magnify fs-15" style="position: absolute; left: 10px;top:8px"></i>
                        <i v-if="search_key !=''" class="icon icon-close fs-16" style="position: absolute; right: 10px;padding-top:4px;color: #707070 !important;cursor: pointer;background-color: #fff;padding-left: 6px;border-top-right-radius: 10px;margin-top: 4px;" @click="clearSearch"></i>
                        <input ref="searchInput" class="w-100 placeholder-text" type="text" v-model="search_key" @input="uncheckSelected(), getListViewData()" placeholder="Search by Survey name , Owner name, Industry Type" style="border-radius: 20px 20px 20px 20px; padding-left: 30px; height: 2.9em;padding-right: 10px;">
                    </div>
                </div>
            </div>
            <div class="table-block pt-10" style="overflow: auto;background-color:#fff;border-top-right-radius:5px">
                <!-- Table view Section -->
                <table class="team-list-table w-100">
                    <thead>
                        <tr>
                            <th style="width: 10px !important;padding: 13px 18px !important">
                                <!-- <input type="checkbox" v-model="check_all" @change="checkAll" name="select_all" /> -->
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" v-model="check_all" @change="checkAll" name="select_all" />
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </th>
                            <th class="text-uppercase">Survey Name</th>
                            <th class="text-uppercase">Owner Name </th>
                            <th class="text-uppercase">Industry Type</th>
                            <th class="text-uppercase">Survey Type</th>
                            <th class="text-uppercase">Responses</th>
                            <th class="text-uppercase">Creation date</th>
                            <th class="text-uppercase">Closure date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="w-100" v-if="ajax_call_in_progress && !list_view_data.length">
                            <td colspan="8">
                                <div class="d-flex align-items-center justify-content-center w-100" v-if="ajax_call_in_progress">
                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                </div>
                            </td>
                        </tr>
                        <tr v-if="!ajax_call_in_progress && list_view_data.length == 0" class="text-center font-weight-bold" style="height: 400px;">
                            <td colspan="8">
                                <img src="/static/images/contact-list.png" class="mb-3" style="width: 30%!important; height: 50%!important;"/><br><br>
                                <div class="text-center"> No Survey Forms added!</div>
                            </td>
                        </tr>
                        <tr v-else v-for="(survey, survey_index) in list_view_data" :key="survey_index">
                            <td style="width: 10px !important;padding: 13px 18px !important">
                                <!-- <input type="checkbox" v-model="survey.checked" @change="selectSurvey($event, survey.id, survey_index)"
                                        name="select_one" /> -->
                                <!-- <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" v-model="survey.checked" @change="selectSurvey($event, survey.id, survey_index)"
                                        name="select_one" />
                                    <span class="custom-control-indicator" style="color: #fff !important; font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label> -->
                                <label class="custom-control custom-checkbox digi-checkbox" style="width: 10px !important;padding-right: 0px !important;min-width: 10px;">
                                    <input type="checkbox" class="custom-control-input" v-model="survey.checked" @change="selectSurvey($event, survey, survey_index)"
                                        name="select_one" />
                                    <span class="custom-control-indicator" style="font-size: 20px; top: -10px !important;"></span>
                                    <span class="form-check-description fw-600"></span>
                                </label>
                            </td>
                            <td>
                                <span class="text-secondary pointer" @click="goToViewSurvey(survey.id)">{{survey.title || "-"}}</span>
                            </td>
                            <td>
                                {{survey.owner_name || "-"}}
                            </td>
                            <td class="text-truncate" :title="survey.industry_type">
                                {{survey.industry_type || "-"}}
                            </td>
                            <td>
                                {{survey.type_survey || "-"}}
                            </td>
                            <td>
                                {{survey.responses || "0"}}
                            </td>
                            <td>
                                {{moment(survey.start_date).format("MM/DD/YYYY") || "-" || "-"}}
                            </td>
                            <td>
                                {{moment(survey.end_date).format("MM/DD/YYYY") || "-" || "-"}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Pagination Section -->
            <div v-if="list_view_data.length" class="d-flex justify-content-end align-items-center bg-white py-2 px-4 bottom-radius">
                <multiselect class="diginew-multiselect list-view-number-dropdown no-default-icon down-arrow"
                    :options="pageLimit" :close-on-select="true" v-model.number="limit"
                    :max-height="210" :allow-empty="false" :searchable="false"
                    open-direction="top" :show-labels="false" placeholder=""
                    style="width: 4.2em !important;padding-right: 10px!important;">
                </multiselect>
                <span class="page-info pr-6 fw-500 text-dark font-size-small">Per page</span>
                <button @click="firstPage()" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                        <i class="icon-chevron-double-left"></i>
                    </el-tooltip>
                </button>
                <button @click="previousPage()" :class="skip == 0 ? 'not-allowed' : 'pointer'" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                        <i class="icon icon-chevron-left"></i>
                    </el-tooltip>
                </button>
                <span class="px-4 fw-500 fs-14 mt-1 font-size-small">Showing {{getSkipCount}} -
                    {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                <button @click="nextPage()" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total"
                    class="pagination-list mt-1 mr-2 pointer">
                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                        <i class="icon icon-chevron-right"></i>
                    </el-tooltip>
                </button>
                <button @click="lastPage()" class="mt-1 pointer pagination-list" :class="temp_total+10 >= total ? 'not-allowed' : 'pointer'" :disabled="temp_total+10 >= total">
                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                        <i class="icon-chevron-double-right"></i>
                    </el-tooltip>
                </button>
            </div>
        </div>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <delete-survey modal_name="deleteSurvey" @deleteSurveys="deleteSurveys" @cancelDelete="cancelDelete" v-if="delatesurveymodal"></delete-survey>
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { HalfCircleSpinner } from "epic-spinners";
import { HollowDotsSpinner } from "epic-spinners";
import survey_forms from '../mixins/survey_forms';
import DeleteSurvey from "../alertModals/DeleteSurvey";
import { debounce } from 'lodash';
import moment from 'moment';
export default {
    data() {
        return {
            disableDelete: false,
            warning_msg: '',
            success_msg: '',
            skip: 0,
            limit: 10,
            count: 0,
            start: 0,
            search_key: '',
            end: 0,
            total: 0,
            skip_temp: 0,
            temp_total: 0,
            ajax_call_in_progress: false,
            pageLimit: [],
            checked: false,
            check_all: false,
            list_view_data: [],
            survey_form_selected: [],
            delatesurveymodal: false,
        }
    },
    mixins:[survey_forms],
    components: {
        SweetModal,
        HalfCircleSpinner,
        HollowDotsSpinner,
        DeleteSurvey
    },
    methods: {
        clearSearch(){
            this.search_key = "";
            this.$refs.searchInput.focus();
            this.getListViewDataDebouncer();
        },
        uncheckSelected(){
            this.survey_form_selected = [];
            this.check_all = false;
        },
        showDeleteSurvey() {
            this.delatesurveymodal = true
            setTimeout(() => {
                this.$modal.show('deleteSurvey')
            }, 500)
        },
        deleteSurveys(){
            this.deleteSurveyForm();
        },
        cancelDelete(){
            this.delatesurveymodal = false;
        },
        moment(date) {
            return moment(date);
        },
        selectSurvey(event, survey, index) {
            if(event.target.checked){
                this.survey_form_selected.push(survey.id)
            } else {
                this.survey_form_selected.forEach((selected_survey, selected_survey_index) => {
                    if(selected_survey === survey.id){
                        this.survey_form_selected.splice(selected_survey_index, 1)
                    }
                })
            }
            if(this.list_view_data.every(x => x.checked == true)){
                this.check_all = true;
            } else {
                this.check_all = false;
            }
        },
        checkAll(event) {
            if(event.target.checked === true){
                this.list_view_data.forEach((el_survey, index) => {
                    if(this.list_view_data[index].checked == false){
                        this.list_view_data[index].checked = true;
                        this.survey_form_selected.push(el_survey.id)
                    }
                })
            } else {
                this.list_view_data.forEach((el_survey, index) => {
                    this.list_view_data[index].checked = false;
                })
                this.list_view_data.forEach((survey_list, survey_list_index) => {
                    this.survey_form_selected.forEach((selected_survey, selected_survey_index) => {
                        if(survey_list.id == selected_survey){
                            this.survey_form_selected.splice(selected_survey_index, 1)
                        }
                    })
                })
            }
        },
        previousPage() {
            this.temp_total = 0
            this.skip_temp = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getListViewDataDebouncer();
            //this.check_all = false;
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
           // this.check_all = false;
            this.getListViewDataDebouncer();
        },
        firstPage() {
            this.temp_total = 0
            this.skip = 0
            this.limit = this.limit
            // this.list_view_data = []
            //this.check_all = false;
            this.getListViewDataDebouncer();
        },
        lastPage() {
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total / this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            //this.check_all = false;
            this.getListViewDataDebouncer();
        },
        async getListViewDataDebouncer() {
            this.list_view_data = [];
            //this.check_all = false;
            //this.survey_form_selected = [];
            this.ajax_call_in_progress = true;
            try {
                let params = {
                    skip: this.skip,
                    limit: this.limit == "" || this.limit == null || this.limit == undefined || this.limit == 0 || this.limit < 0 ? 10 : this.limit,
                    search: this.search_key
                }
                let response = await this.getSurveyForm(params);
                this.list_view_data = response.response.forms;
                if(this.list_view_data.length != 0){
                    this.list_view_data.forEach((survey, index) => {
                        this.list_view_data[index].checked = false;
                        if(this.survey_form_selected.length){
                            this.survey_form_selected.forEach((el_selected, el_selected_index) => {
                                if(el_selected === survey.id){
                                    this.list_view_data[index].checked = true;
                                }
                            })
                        }
                    })
                    if(this.list_view_data.every(x => x.checked == true)){
                        this.check_all = true;
                    } else {
                        this.check_all = false;
                    }
                }
                this.total = response.count;
                this.ajax_call_in_progress = false;
            }
            catch(error) {
                this.ajax_call_in_progress = false;
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        goToViewSurvey(id) {
            if(this.userPermissions.survey_forms.permitted_actions.view){
                this.$router.push('/surveyform/view/'+id);
            }
            else{
                this.$toasted.global.error("Permission Denied")
            }
        },
        async deleteSurveyForm() {
            this.disableDelete = true;
            try {
                let param = {
                    id: this.survey_form_selected
                };
                let response = await this.deleteSurveyFormById(param);
                this.delatesurveymodal = false;
                this.success_msg = response.message;
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.disableDelete = false;
                    this.$refs.success_modal.close();
                    this.getListViewDataDebouncer();
                }, 3000);
            }
            catch(error) {
                this.warning_msg = error
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.disableDelete = false;
                    this.$refs.warning_modal.close();
                    this.getListViewDataDebouncer();
                }, 3000);
            }
        }
    },
    computed: {
        getSkipCount() {
            if (this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                return skip_count;
            }
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        }
    },
    mounted() {
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        this.getListViewDataDebouncer();
    },
    created() {
        this.getListViewData = debounce(this.getListViewDataDebouncer, 500)
    },
    watch: {
        limit: function(){
            this.getListViewDataDebouncer();
        }
    },
}
</script>

<style scoped>
    .team-list-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 15px 30px;
        font-size: 16px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-list-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-list-table thead tr th:last-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .bottom-radius{
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    .team-list-table tbody tr td {
        background: #fff;
        padding: 20px 30px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: 1px solid #f2f3f5;
        white-space: nowrap;
    }
    .team-list-table tbody tr td span img {
        width: 30px !important;
        height: 30px !important;
        margin-left: -10px;
    }
    .text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 200px !important;
    }
    .font-size-small{
        height: 2.4rem;
        line-height: 2.4rem;
        color: #4e5764;
        font-size: 14px;
    }
    .placeholder-text:focus {
        padding: 8px 9.4px 8px 30px;
        border-radius: 18px !important;
        background-color: #fff;
        border: 0.3px solid #707070 !important;
        width: 100%;
    }
    @media only screen and (max-width: 510px) {
        .font-size-small{
            font-size: 12px !important;
            padding-left: 0px !important;
        }
    }
    @media only screen and (max-width: 486px) {
        .margin486{
            margin-bottom: 10px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SurveyForms/ListSurveyForms.vue